export default __webpack_public_path__ + "static/media/emptyImage.cf8e5168.svg";